import { render } from "./ManageGallery.vue?vue&type=template&id=6e4249e0&scoped=true"
import script from "./ManageGallery.vue?vue&type=script&lang=js"
export * from "./ManageGallery.vue?vue&type=script&lang=js"

import "./ManageGallery.vue?vue&type=style&index=0&id=6e4249e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4249e0"]])

export default __exports__